
export const FORM_SERVICE = getApiUrlByDomain(process.env.REACT_APP_URL_FORM_SERVICE)
export const SECURE_FORM_SERVICE = getApiUrlByDomain(process.env.REACT_APP_URL_SECURE_FORM_SERVICE)
export const USER_SERVICE = getApiUrlByDomain(process.env.REACT_APP_URL_USER_SERVICE)


function getApiUrlByDomain(baseUrl){
    let newBaseUrlWithDomain=baseUrl
    let currentDomain = window.location.hostname

    // if(!currentDomain.includes("localhost")){
    //     let splitDomain = currentDomain.split(".")[1]
    //     newBaseUrlWithDomain  = newBaseUrlWithDomain.split(".")
    //     newBaseUrlWithDomain[1]=splitDomain
    //     newBaseUrlWithDomain=newBaseUrlWithDomain.join(".")
    // }
    return newBaseUrlWithDomain
}
